module.exports = __webpack_public_path__ + "img/24_newYouth_wzc.0d969aed.png";